import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

///
/// This state presents the signup form
///

// Register the application's routes configuration.
angular.module('flowingly.signup').config(config);

// Inject the dependencies.
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.signup, {
    url: '/signup',
    params: { title: 'Sign Up' },
    templateUrl: 'Client/signup/signup.tmpl.html',
    controller: 'signupController',
    controllerAs: 'ctrl'
  });
}
